export default "__VITE_ASSET__C27AsK0Q__"